
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-130a652a&scoped=true!../../../../vue-loader/lib/selector?type=styles&index=0!./LoopingRhombusesSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./LoopingRhombusesSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-130a652a!../../../../vue-loader/lib/selector?type=template&index=0!./LoopingRhombusesSpinner.vue"),
  /* scopeId */
  "data-v-130a652a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/LoopingRhombusesSpinner.vue
// module id = 867
// module chunks = 1